import ApiService from '../../../../../services/ApiService'
import Utils from '../../../../../Utils/FormatDate'
import SignatureScreen from '../../../../../components/SignatureScreen.vue'

export default {
  components: {
    SignatureScreen,
  },

  props: {},

  async created() {
    this.currentUser = JSON.parse(localStorage.getItem('user'))
    this.institution = JSON.parse(localStorage.getItem('institution'))

    await this.getUser()

    this.userLevel = this.levels[this.institution.userType]

    this.createDate = this.formatDateTime(this.currentUser.createdAt)

    this.getDevices()
  },

  data: () => ({
    institution: {},
    devices: [],
    step: 0,
    errorMessage: '',
    successMessage: '',
    loading: false,
    preferencesLoading: false,
    informationLoading: false,
    signatureLoading: false,
    removeLoading: false,
    firstValid: true,
    secondValid: true,
    thirdValid: true,
    alterDialog: false,
    changedData: false,
    showSuccess: false,
    error: false,
    removeSignatureDialog: false,
    buttonDisable: false,
    password: '',
    passwordConfirmation: '',
    userLevel: null,
    profileImage: null,
    profileImageData: null,
    professionalRegistration: null,

    signatureImageData: null,
    signatureMode: 0,
    imageType: null,
    createDate: null,
    image: {
      height: 0,
      width: 0,
    },
    currentUser: {},
    levels: [
      'Master',
      'Administrador',
      'Supervisor',
      'Operador',
      'Coordenador Op.',
      'Coordenado Setor Assinatura',
      'Solicitador',
    ],
    nameRules: [
      (v) => !!v || 'Nome requerido',
      (v) => (v && v.length <= 128) || 'Nome deve ter no máximo 128 caracteres',
    ],
    emailRules: [
      (v) => !!v || 'E-mail requerido',
      (v) => /.+@.+\..+/.test(v) || 'E-mail inválido',
    ],
    phoneNumberRules: [
      (v) => !!v || 'Telefone requerido',
      (v) => (v && v.length > 13) || 'Telefone inválido',
    ],
    cellPhoneNumberRules: [
      (v) => !!v || 'Celular requerido',
      (v) => (v && v.length > 14) || 'Celular inválido',
    ],
    apiService: new ApiService(),
    fcmLoading: false,
  }),

  computed: {},

  methods: {
    async getUser() {
      this.loading = true

      await this.apiService
        .get(`user/${this.currentUser.id}`)
        .then((response) => {
          this.currentUser = response.content
          if (this.currentUser.audioVolumeCalleds == null) {
            this.currentUser.audioVolumeCalleds = 100
          }
          this.profileImage = this.currentUser.profileImage
            ? `${this.currentUser.profileImage}?t=${Date.now()}`
            : null
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },

    async enableDevice() {
      const userAgent = navigator.userAgent
      let browser = 5

      if (userAgent.match(/chrome|chromium|crios/i)) {
        browser = 2
      } else if (userAgent.match(/firefox|fxios/i)) {
        browser = 1
      } else if (userAgent.match(/safari/i)) {
        browser = 3
      } else if (userAgent.match(/opr\//i)) {
        browser = 0
      } else if (userAgent.match(/edg/i)) {
        browser = 4
      } else {
        browser = 5
      }

      let token = ''

      await this.$messaging
        .getToken(this.$messaging.messaging, {
          vapidKey:
            'BL3oaTl_6ICXaPRmp608zfqDqIj46_Xnx2F3weeKG7_ABZhRJd9LPKGrA7WDzA6p7A_LNgbobUw43HrUc3PjVhQ',
        })
        .then((currentToken) => {
          if (currentToken) {
            token = currentToken
          }
        })
        .catch((err) => {
          this.$toast.error(
            'Ops! Não conseguimos habilitar seu dispositivo 😕 Dá uma olhadinha nas permissões de notificação e pop-ups do site!'
          )
          return
        })

      if (token) {
        let device = 0

        if (
          /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
            navigator.userAgent
          )
        ) {
          // true for mobile device
          device = 1
        }

        this.fcmLoading = true
        this.apiService
          .post('userFCM', {
            token,
            browser,
            device,
          })
          .then(() => {
            this.$toast.success('Dispositivo habilitado com sucesso!')
            this.getDevices()
            this.fcmLoading = false
          })
          .catch(() => {
            this.fcmLoading = false
          })
      }
    },

    getDevices() {
      this.fcmLoading = true
      this.apiService
        .get('userFCM')
        .then((response) => {
          this.devices = response.content
          this.fcmLoading = false
        })
        .catch(() => {
          this.fcmLoading = false
        })
    },

    close() {
      if (this.changedData) {
        this.alterDialog = true
      } else {
        this.$router.go(-1)
      }
    },

    closeDialog() {
      this.changedData = false
      this.close()
    },

    showSuccessAlert(message) {
      this.$toast.success(this.$t(message))
    },

    minLength(v) {
      if (v && v.length) {
        if (v.length < 8) {
          return 'Mínimo de 8 caracteres'
        }
      }
      return true
    },

    specialCharacters(v) {
      if (v && v.length) {
        const specialCharacters = /[!@#$%^&*()_+[\]{};:'"<>,.?/~\\-]/

        if (specialCharacters.test(v) == false)
          return 'Mínimo de um caractere especial'

        return true
      }
      return true
    },

    uppercaseLetter(v) {
      if (v && v.length) {
        const uppercaseLetter = /[A-Z]/

        if (uppercaseLetter.test(v) == false)
          return 'Mínimo de uma letra maiúscula'

        return true
      }
      return true
    },

    saveProfileImage(value) {
      if (value) {
        this.profileImage =
          value.size < 2000000 ? URL.createObjectURL(value) : null
        this.imageType = value.type.split('/')[1]

        var reader = new FileReader()
        reader.readAsDataURL(value)
        reader.onload = () => {
          this.profileImageData = reader.result
        }
      } else {
        this.profileImage = null
        this.imageType = null
      }
    },

    saveSignatureImage(value) {
      if (value) {
        this.signatureImage = ''
        this.buttonDisable = false
        this.error = false
        this.errorMessage = ''

        var reader = new FileReader()
        reader.readAsDataURL(value)
        reader.onload = (evt) => {
          let img = new Image()
          img.src = evt.target.result
          img.onload = () => {
            if (img.width > 321 && img.height > 100) {
              this.error = true
              this.errorMessage =
                'Imagem inválida: A imagem da assinatura deve possuir no máximo 320x99 pixels'
              this.buttonDisable = true
            } else {
              this.signatureImage = img.size > 2000000 ? '' : img.src
              this.imageType = value.type.split('/')[1]
              this.signatureImageData = img.src
              this.currentUser.signatureImage = img.src
            }
          }
        }
      } else {
        this.signatureImage =
          this.currentUser.signatureImage != null
            ? `data:image/png;base64,${this.currentUser.signatureImage}`
            : ''
        this.imageType = null
      }
    },

    async submitPreferences() {
      if (this.$refs.firstForm.validate()) {
        this.preferencesLoading = true

        const { institutions, ...user } = this.currentUser

        const userEditModel = {
          ...user,
          Id: this.currentUser.id,
          Name: this.currentUser.name,
          Email: this.currentUser.email,
          Password: this.password,
          ProfileImage: this.profileImageData,
          FileType: this.imageType,
          EditUserType: 1,
          professionalRegistration: this.currentUser.professionalRegistration,
        }

        await this.apiService
          .post('user/edit', userEditModel)
          .then((response) => {
            window.scrollTo(0, 0)
            this.showSuccessAlert('Preferências atualizadas com sucesso')
            this.changedData = false
            this.currentUser.profileImage = response.content.profileImage
            this.currentUser.sessionId = response.content.sessionId
            this.profileImage = response.content.profileImage
              ? `${response.content.profileImage}?t=${Date.now()}`
              : null
            localStorage.setItem('user', JSON.stringify(this.currentUser))
            this.$root.$emit('update')
          })
          .catch((err) => {
            window.scrollTo(0, 0)
            this.errorMessage = err.message
            this.error = true

            setTimeout(() => {
              this.error = false
            }, 4000)
          })
      } else {
        this.$refs.firstForm.$el.scrollIntoView({ behavior: 'smooth' })
      }
      this.preferencesLoading = false
    },

    async submitInformation() {
      if (this.$refs.secondForm.validate()) {
        this.informationLoading = true

        const { institutions, ...user } = this.currentUser

        const userEditModel = {
          ...user,
          Id: this.currentUser.id,
          PhoneNumber: this.currentUser.phoneNumber,
          CellPhoneNumber: this.currentUser.cellPhoneNumber,
          audioInCalleds: this.currentUser.audioInCalleds,
          audioVolumeCalleds: this.currentUser.audioVolumeCalleds,
          EditUserType: 2,
        }

        await this.apiService
          .post('user/edit', userEditModel)
          .then((response) => {
            window.scrollTo(0, 0)
            this.showSuccessAlert('Informações atualizadas com sucesso')
            this.changedData = false
            localStorage.setItem('user', JSON.stringify(response.content))
          })
          .catch((err) => {
            window.scrollTo(0, 0)
            this.errorMessage = err.message
            this.error = true

            setTimeout(() => {
              this.error = false
            }, 4000)
          })
      } else {
        this.$refs.secondForm.$el.scrollIntoView({ behavior: 'smooth' })
      }
      this.informationLoading = false
    },

    getSignatureBounds(context, width, height) {
      const { data } = context.getImageData(0, 0, width, height)

      let top = height
      let left = width
      let right = -1
      let bottom = -1

      for (let y = 0; y < height; y++) {
        for (let x = 0; x < width; x++) {
          if (data[(y * width + x) * 4 + 3] === 0) continue

          if (y < top) top = y
          if (y > bottom) bottom = y
          if (x < left) left = x
          if (x > right) right = x
        }
      }

      if (right < left || bottom < top) return null

      return { left, top, width: right - left + 1, height: bottom - top + 1 }
    },

    resizeSignature(data) {
      return new Promise((resolve, reject) => {
        const img = new Image()

        img.onload = () => {
          const source = document.createElement('canvas')
          source.width = img.width
          source.height = img.height

          const sourceContext = source.getContext('2d')
          sourceContext.drawImage(img, 0, 0)

          const bounds =
            this.getSignatureBounds(sourceContext, img.width, img.height) ??
            { left: 0, top: 0, width: img.width, height: img.height }

          const padding = 4
          const scale = Math.min(
            (320 - padding * 2) / bounds.width,
            (99 - padding * 2) / bounds.height,
            1
          )
          const width = bounds.width * scale
          const height = bounds.height * scale

          const canvas = document.createElement('canvas')
          canvas.width = 320
          canvas.height = 99

          const context = canvas.getContext('2d')
          context.drawImage(
            source,
            bounds.left,
            bounds.top,
            bounds.width,
            bounds.height,
            (320 - width) / 2,
            (99 - height) / 2,
            width,
            height
          )

          resolve(canvas.toDataURL('image/png'))
        }

        img.onerror = () => reject(new Error('Assinatura inválida'))
        img.src = data
      })
    },

    async saveDrawnSignature(data) {
      if (!data) return

      this.error = false
      this.errorMessage = ''
      this.imageType = 'png'

      try {
        this.signatureImageData = await this.resizeSignature(data)
      } catch {
        this.errorMessage = 'Não foi possível processar a assinatura desenhada'
        this.error = true
        return
      }

      await this.sendSignature()
    },

    async submitSignature() {
      if (this.$refs.thirdForm.validate()) {
        await this.sendSignature()
      } else {
        this.$refs.thirdForm.$el.scrollIntoView({ behavior: 'smooth' })
      }
    },

    async sendSignature() {
      this.signatureLoading = true

      const userEditModel = {
        ...this.currentUser,
        Id: this.currentUser.id,
        SignatureImage: this.signatureImageData,
        FileType: this.imageType,
        EditUserType: 3,
      }

      await this.apiService
        .post('user/edit', userEditModel)
        .then((response) => {
          window.scrollTo(0, 0)
          this.showSuccessAlert('Assinatura salva com sucesso')
          this.changedData = false
          this.currentUser.signatureImage = response.content.signatureImage
          localStorage.setItem('user', JSON.stringify(this.currentUser))
        })
        .catch((err) => {
          window.scrollTo(0, 0)
          this.errorMessage = err.message
          this.error = true

          setTimeout(() => {
            this.error = false
          }, 4000)
        })

      this.signatureLoading = false
    },

    async removeSignature() {
      this.removeLoading = true

      const user = {
        Id: this.currentUser.id,
        SignatureImage: null,
      }

      await this.apiService
        .delete('user/removeSignature', user)
        .then((response) => {
          window.scrollTo(0, 0)
          this.showSuccessAlert(response.message)
          this.changedData = false
          this.removeSignatureDialog = false
          this.currentUser.signatureImage = null
          localStorage.setItem('user', JSON.stringify(this.currentUser))
          this.signatureImage = ''
        })
        .catch((err) => {
          window.scrollTo(0, 0)
          this.errorMessage = err.message
          this.error = true

          setTimeout(() => {
            this.error = false
          }, 4000)
        })
      this.removeLoading = false
    },

    formatDateTime(date) {
      return Utils.dateTime(date)
    },
  },

  watch: {
    currentUser: {
      deep: true,
      handler() {
        this.changedData = true
      },
    },
  },
}
